(() => {
  /*============================================================================
   CRM Modal custom functions
  ==============================================================================*/

  const saveHeaderNewsletterID = () => {
    localStorage.setItem("headerNewsletterFormID", "topNewsletterForm");
  };

  // Hide disclaimers based on screen size
  const hideDisclaimers = () => {
    if (window.innerWidth > 1000) {
      domItems?.mobileDisclaimers?.forEach((disclaimer) => {
        disclaimer.remove();
      });
    } else {
      domItems?.desktopDisclaimers?.forEach((disclaimer) => {
        disclaimer.remove();
      });
    }
  };

  // Handle modal display, only show if not hidden by guild_popup=off or if not seen before
  const handleModalDisplay = () => {
    if (domItems?.hideGuildPopup) {
      return;
    }

    if (domItems?.hasSeenHeaderNewsletterSignUp === false || domItems?.hasSeenHeaderNewsletterSignUp === "false") {
      domItems?.crmModal?.classList?.add("show-crmModal");
      localStorage.setItem("hasSeenHeaderNewsletterForm", true);
      saveHeaderNewsletterID();
    }
  };

  // Open modal on mobile / Global function.
  window.crmModalMobile = () => {
    var elementMobile = document.getElementById("crmModal2");
    elementMobile.classList.add("show-crmModal");
  };

  /**
   * Event listeners on CRM Modal DOM items.
   *
   * @param none
   */

  const eventListeners = () => {
    // Form submission
    domItems.newsletterForm.addEventListener("submit", (e) => {
      jsvarFormSuccess = domItems?.newsletterSuccess?.value; // To override the global var.
      window.jsvarFormSuccess = domItems?.newsletterSuccess?.value;
      domItems.crmModal.classList.add("success-message");
      saveHeaderNewsletterID();
    });

    window.addEventListener("click", (event) => {
      if (event.target === domItems?.crmModal) {
        domItems?.crmModal?.classList?.toggle("show-crmModal");
      }
    });

    domItems?.closeButton?.addEventListener("click", () => {
      domItems?.crmModal?.classList?.toggle("show-crmModal");
    });
  };

  /**
   * Load event on CRM Modal.
   *
   * @param none
   */

  let domItems = {};
  const onLoad = async () => {
    domItems = {
      closeButton: document.querySelector(".closecrmModal2"),
      crmModal: document.querySelector("#crmModal2"),
      hasSeenHeaderNewsletterSignUp:
        localStorage.getItem("hasSeenHeaderNewsletterForm") || false,
      hideGuildPopup:
        window.location.search.includes("guild_popup=off") || null,
      mobileDisclaimers: domItems?.crmModal?.querySelectorAll(
        ".crm-disclaimers.disclaimers.mobile"
      ),
      desktopDisclaimers: domItems?.crmModal?.querySelectorAll(
        ".crm-disclaimers.disclaimers.desktop"
      ),
      newsletterForm: document.querySelector("#headerNewsletterFormID"),
      newsletterSuccess: document.querySelector("[name='form_success']"),
    };

    handleModalDisplay();
    hideDisclaimers();

    // eventListeners();
  };

  if (document.readyState === "complete") {
    onLoad();
  } else {
    window.addEventListener("load", onLoad);
  }
})();
